// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-home-header[data-v-467dc5d8]{height:60vh}.certificado-badge[data-v-467dc5d8]{position:absolute;z-index:3;left:7%;top:25%;width:110px;height:110px;border-radius:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
